var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9703 27.3185L9.49551 36.4469C9.29451 37.6948 9.78585 38.9525 10.7662 39.6972C11.7481 40.4404 13.0519 40.5399 14.1247 39.954L22 35.67L29.8752 39.9549C30.3411 40.2069 30.8517 40.3337 31.3569 40.3337C32.0184 40.3337 32.6784 40.1178 33.2352 39.698C34.2164 38.9533 34.7092 37.6956 34.5067 36.4477L33.0335 27.3193L39.3746 20.837C40.2418 19.9518 40.5506 18.6308 40.1786 17.4285C39.8051 16.2271 38.8055 15.3475 37.6057 15.1629L28.8186 13.805L24.8609 5.51529C24.3242 4.38368 23.2121 3.66699 21.9992 3.66699C20.7886 3.66699 19.6773 4.38368 19.1359 5.51529L15.1821 13.805L6.39501 15.1621C5.19285 15.3467 4.19786 16.2263 3.82358 17.4277C3.4493 18.63 3.75735 19.9526 4.62604 20.8362L10.9703 27.3185Z",
    fill: "#FFDE3B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon-star.dd72a4f52b01714e10951544c93e335c.svg";
export { ForwardRef as ReactComponent };